/**
 * Auth0-reactのutilsの関数の実装をそのまま持ってきて使用する
 *
 * @see https://github.com/auth0/auth0-react/blob/4a76db3de764aaaa52e4a8d376165aa35e4d9c81/src/utils.tsx#L3-L9
 */

const CODE_RE = /[?&]code=[^&]+/;
const STATE_RE = /[?&]state=[^&]+/;
const ERROR_RE = /[?&]error=[^&]+/;

export const hasAuthParams = (searchParams = window.location.search): boolean =>
  (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) && STATE_RE.test(searchParams);
